import React from 'react';
import moment from 'moment';
import { getNumberFormat, colorCategory } from 'utils/helpers';
import CategoryIcons from 'library/categoryIcons';
import NoDataMsg from 'library/noData';


const storageIcon = <span className="glyphicon glyphicon-list-alt blue-text"><p className="transferIcons">Storage</p></span>;
const storeIcon = <span className="glyphicon glyphicon-home green-text"><p className="transferIcons">Store</p></span>;
const damageIcon = <span className="glyphicon glyphicon-remove-circle danger"><p className="transferIcons">Damage</p></span>;

const Body = ({ inventorySnapShot, selectedDate, allAccess }) => (
    <React.Fragment>
        {
            inventorySnapShot.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="text-center list_header">
                        {selectedDate ?
                            <p><i>Selected Date</i> <b>{moment(selectedDate).format('MMMM Do, YYYY')}</b></p>
                            : ""}
                    </div>

                    <div className="mt-2 pl-2 pr-2">
                        {
                            inventorySnapShot.map((item, index) => {
                                //const totalInventory = item.storage + item.store  + item.damage;
                                const categoryStyle = {
                                    background: {
                                        backgroundColor: colorCategory(item.classOfCannabis)
                                    },
                                    textColor: {
                                        color: colorCategory(item.classOfCannabis)
                                    }
                                }
                                return (
                                    <div className="row m-0 border_bottom_grey mb-1 pb-1 position-relative" key={index}>
                                        <div className="col-lg-5 m-0 p-0">
                                            <div className="row m-0">
                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 m-0 p-0 catIcon" style={categoryStyle.background}>
                                                    <CategoryIcons
                                                        type={item.classOfCannabis}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 pl-2 pt-1 reduce-margin-top-report" style={categoryStyle.textColor}>
                                                    <h3 className="m-0 font-weight-semibold">{item.productName}</h3>
                                                    <span className="capitalize">
                                                        {item.classOfCannabis == null ? "Uncategorized, " + item.categoryName : item.classOfCannabis + ", " + item.categoryName} <br />
                                                    </span>
                                                    <h6>SKU:[{item.sku}] </h6>
                                                    <h6>BranchName:[{item.branchName}] </h6>
                                                    <h6>Price:${item.price.toFixed(2)} </h6>
                                                    <h6>Member Price:${item.memberPrice.toFixed(2)} </h6>
                                                    <h6>UPC:[{item.barcode}] </h6>
                                                    <h6>Weight:[{item.weight}] </h6>
                                                    <h6>THC: [ Max:{item.thcMax} - Min:{item.thcMin} ]</h6>
                                                    <h6>CBD [ Max:{item.cbdMax} - Min:{item.cbdMin} ]</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 m-0 p-0">
                                            {
                                                allAccess &&
                                                <div>
                                                    <div className="row m-0">
                                                        Latest Unit Cost: ${item.latestBaseCost}
                                                    </div>
                                                    <br />
                                                    <div className="row m-0">
                                                        Total Value (Latest Unit Cost): ${item.totalValueFromLatestCost.toFixed(2)}
                                                    </div>
                                                    <br />
                                                    <div className="row m-0">
                                                        Weighted Average Cost: ${item.wac}
                                                    </div>
                                                    <br />
                                                    <div className="row m-0">
                                                        Total Value (Weighted Average Cost): ${item.totalValueFromWAC.toFixed(2)}
                                                    </div>
                                                    <br />
                                                </div>
                                            }

                                            <div className="row m-0">
                                                Location : {item.location}
                                            </div>
                                            <br />
                                            <div className="row m-0">
                                                Latest THC : {item.thcLevel}
                                            </div>
                                            <br />
                                            <div className="row m-0">
                                                Latest CBD : {item.cbdLevel}
                                            </div>
                                            <br />
                                            <div className="row m-0">
                                                Species : {item.species}
                                            </div>
                                        </div>
                                        <div className="col-lg-5 m-0 p-0">
                                            <div className="row m-0">
                                                <div className="col-lg-4 m-0 p-0">
                                                    <label>{storageIcon}</label>
                                                    <h3 className="m-0">{getNumberFormat(item.storageQuantity)}</h3>
                                                </div>
                                                <div className="col-lg-4 m-0 p-0">
                                                    <label>{storeIcon}</label>
                                                    <h3 className="m-0">{getNumberFormat(item.storeQuantity)}</h3>
                                                </div>
                                                <div className="col-lg-4 m-0 p-0">
                                                    <label>{damageIcon}</label>
                                                    <h3 className="m-0">{getNumberFormat(item.damageQuantity)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
        }
    </React.Fragment>
);
export default Body;